import React, { useEffect } from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { setHasImportantUnsavedChanges } from '@rd-web-markets/shared/dist/store/features/unsavedChangesSlice';
import { useTranslation } from 'react-i18next';
import ReportNotesForm from '@rd-web-markets/market/dist/technicalProof/summarySection/ProjectNotesForm';
import ReportNotesTable from '@rd-web-markets/market/dist/technicalProof/summarySection/ProjectNotesTable';
const ClaimProjectNotes = _ref => {
  let {
    isImmutableUnderReview,
    report,
    setReport,
    pageAccess,
    reportNotesHandlers
  } = _ref;
  const dispatch = useDispatch();
  const {
    t
  } = useTranslation();
  const currentUser = useSelector(state => state.auth.user);
  const {
    notes,
    setNotes,
    createNote,
    updateNote,
    deleteNote,
    loading
  } = reportNotesHandlers;
  useEffect(() => {
    if (report.report_notes) {
      setNotes(report.report_notes);
    }
  }, [report.id, report.report_notes?.length]);
  const handleCreateNote = async formData => {
    try {
      const response = await createNote(formData);
      const updatedNotes = [response, ...notes];
      setNotes(updatedNotes);
      report.report_notes = updatedNotes;
      setReport({
        ...report
      });
      dispatch(setHasImportantUnsavedChanges(false));
    } catch (e) {
      dispatch(handleError(e));
    }
  };
  const handleUpdateNote = async _ref2 => {
    let {
      id,
      data
    } = _ref2;
    try {
      const response = await updateNote({
        id,
        data
      });
      const updatedNotes = notes.map(n => n.id === id ? response : n);
      setNotes(updatedNotes);
      report.report_notes = updatedNotes;
      setReport({
        ...report
      });
    } catch (e) {
      dispatch(handleError(e));
    }
  };
  const handleDeleteNote = async noteId => {
    try {
      await deleteNote(noteId);
      const updatedNotes = notes.filter(n => n.id !== noteId);
      setNotes(updatedNotes);
      report.report_notes = updatedNotes;
      setReport({
        ...report
      });
    } catch (e) {
      dispatch(handleError(e));
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 9
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 8
  }, /*#__PURE__*/React.createElement(ReportNotesForm, {
    loading: loading,
    onSubmit: handleCreateNote,
    noteType: "comments",
    isImmutableUnderReview: isImmutableUnderReview
  }))), /*#__PURE__*/React.createElement(Row, {
    className: "mt-3"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React.createElement(ReportNotesTable, {
    notes: notes,
    onUpdate: handleUpdateNote,
    onDelete: handleDeleteNote,
    userCanEdit: true,
    loading: loading,
    filterByType: null,
    showTypeColumn: true,
    currentUserId: currentUser?.id
  }))))))));
};
export default ClaimProjectNotes;